<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="bg-chsc-indigo-500">
        <UiContainer>
            <div class="flex gap-x-20">
                <div class="realtive w-4/12 flex justify-end max-[769px]:hidden">
                    <img
                        v-motion-pop-visible-once
                        :src="blok?.image.filename"
                        :alt="blok?.image.alt"
                        class="max-w-none"
                    >
                </div>
                <div class="w-8/12 max-[769px]:w-full">
                    <div class="py-20 global-text global-text--white">
                        <StoryblokRichText :doc="blok?.content" />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
